import React, {useState, useEffect, useRef, useContext, Fragment} from "react";
import {useHistory, useParams} from 'react-router-dom'
import Card from "../../../components/Card";
import {Field, Form, Formik} from "formik"
import ModalMsg from "../../../components/ModalMsg";
import * as Yup from "yup";
import {LoaderContext} from "../../../context/LoaderContext";
import {TranslateContext} from "../../../context/TranslateContext";
import LabelErroreCampo from "../../../components/LabelErroreCampo";
import NsFormikScrollToError from "../../../components/NsFormikScrollToError";
import NsBtnBack from "../../../components/buttons/NsBtnBack";
import {
    aggiornaMarcaArchivioApi,
    aggiungiMarcaArchivioApi,
    getMarcaArchivioByIdApi
} from "../../../services/ArchivioServices";

function ModificaMarcaArchivio() {
    const {id} = useParams()

    const [loadingData, setLoadingData] = useState(true);
    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);

    const {startChiamata, endChiamata} = useContext(LoaderContext);
    const {traduci} = useContext(TranslateContext);

    const history = useHistory();
    const formikRef = useRef();

    async function getMarcaArchivio() {
        startChiamata();

        const response = await getMarcaArchivioByIdApi(id);
        let val = response.data.data;
        setLoadingData(false);

        if (formikRef.current) {
            formikRef.current.setFieldValue("id_archivio_marca", val.id_archivio_marca);
            formikRef.current.setFieldValue("marca", val.marca);
        }
        endChiamata();
    }

    useEffect(() => {
        if (loadingData) {
            if (id && id !== '') {
                getMarcaArchivio();
            }
        }
    }, [id]);

    const SignupSchema = Yup.object().shape({
        marca: Yup.string()
            .max(50, traduci('Attenzione! Hai inserito troppi caratteri'))
            .required(traduci('Questo campo è obbligatorio')),
    });

    async function aggiornaMarcaArchivio(values) {
        startChiamata();

        const response = await aggiornaMarcaArchivioApi(id, values);
        endChiamata();

        if (response.data.result === 0) {
            history.goBack();
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    async function aggiungiMarcaArchivio(values) {
        startChiamata();

        const response = await aggiungiMarcaArchivioApi(values);
        endChiamata();

        if (response.data.result === 0) {
            history.goBack();
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    function salvaMarcaArchivio(values) {
        if (id) {
            aggiornaMarcaArchivio(values);
        } else {
            aggiungiMarcaArchivio(values);
        }
    }

    return (
        <Card
            icon={'fas fa-tags'}
            title={id ? 'Modifica Marca Archivio' : 'Inserisci Marca Archivio'}
            getBottoniDx={() =>
                <Fragment>
                    <NsBtnBack/>
                    <button type="button" id="salva" name="salva"
                            className="btn btn-card"
                            onClick={() => {
                                if (formikRef.current) {
                                    formikRef.current.handleSubmit()
                                }
                            }}>
                        <i className="fas fa-save"/> Salva
                    </button>
                </Fragment>
            }
        >
            <ModalMsg
                show={show}
                handleClose={() => setShow(false)}
                testo={modalMsg}/>
            <Formik
                initialValues={{
                    id_archivio_marca: '',
                    marca: ''
                }}
                innerRef={formikRef}
                validationSchema={SignupSchema}
                onSubmit={values => {
                    salvaMarcaArchivio(values);
                }}
            >
                {({errors, touched, submitCount, values}) => (
                    <Form className="row g-3">
                        <div className="col-md-12">
                            <label htmlFor="marca" className="form-label">Marca archivio*:</label>
                            <Field
                                name="marca"
                                className="form-control"
                            />
                            <LabelErroreCampo errors={errors} touched={touched} name={"marca"}
                                              submitCount={submitCount}/>
                        </div>

                        <NsFormikScrollToError submitCount={submitCount} errors={errors}/>
                    </Form>
                )}
            </Formik>
        </Card>
    );
}

export default ModificaMarcaArchivio;